import {
  useTranslation
} from "../../../../chunk-6N4NEKWU.mjs";
import "../../../../chunk-D57E6H3M.mjs";

// src/components/composite/Timeline/OrderStatusCard/OrderStatusTimelineItem.tsx
import { useLayoutEffect, useRef, useState } from "react";
import { staggerDelay } from "../../../../hooks/useEntranceStagger.mjs";
import { Skeleton } from "../../../primitive/Skeleton/Skeleton.mjs";
import { boxOf, unfold } from "../shared/unfold.mjs";
import { OrderStatusCard } from "./OrderStatusCard.mjs";
import { jsx, jsxs } from "react/jsx-runtime";
function OrderStatusCardSkeleton({ ref }) {
  return /* @__PURE__ */ jsxs("div", { ref, className: "buyscout-order-status-card buyscout-timeline-order-status-card buyscout-order-status-skeleton", "aria-busy": true, children: [
    /* @__PURE__ */ jsxs("div", { className: "buyscout-order-status-header", children: [
      /* @__PURE__ */ jsxs("div", { className: "buyscout-order-status-title buyscout-order-status-skeleton-title", children: [
        /* @__PURE__ */ jsx(Skeleton, { width: 112, className: "buyscout-order-status-skeleton-number" }),
        /* @__PURE__ */ jsx(Skeleton, { width: 88, className: "buyscout-order-status-skeleton-placed" })
      ] }),
      /* @__PURE__ */ jsx(Skeleton, { variant: "rect", width: 64, className: "buyscout-order-status-skeleton-badge" })
    ] }),
    /* @__PURE__ */ jsxs("div", { className: "buyscout-order-status-shipment buyscout-order-status-skeleton-shipment", children: [
      /* @__PURE__ */ jsx(Skeleton, { width: "45%", className: "buyscout-order-status-skeleton-status" }),
      /* @__PURE__ */ jsx(Skeleton, { width: "35%", className: "buyscout-order-status-skeleton-date" }),
      /* @__PURE__ */ jsx(Skeleton, { variant: "rect", className: "buyscout-order-status-skeleton-track" })
    ] })
  ] });
}
function ArrivingOrderCard({ order, opening, from, sequence }) {
  const cardRef = useRef(null);
  const openedRef = useRef(false);
  useLayoutEffect(() => {
    const card = cardRef.current;
    if (!card || openedRef.current) return;
    openedRef.current = true;
    if (!opening) return;
    const header = card.querySelector("header");
    const headerHeight = header ? header.getBoundingClientRect().bottom - card.getBoundingClientRect().top + Number.parseFloat(getComputedStyle(card).paddingBottom) : 0;
    unfold(card, from ?? { width: boxOf(card).width, height: headerHeight }, { delay: staggerDelay(sequence), fade: from === void 0 });
  }, [opening, from, sequence]);
  return /* @__PURE__ */ jsx(OrderStatusCard, { ref: cardRef, order });
}
function OrderStatusTimelineItem({ orders, loading = false }) {
  const { t } = useTranslation();
  const [streamed] = useState(loading);
  const skeletonRef = useRef(null);
  const skeletonBoxRef = useRef(void 0);
  const openedRef = useRef(/* @__PURE__ */ new Set());
  useLayoutEffect(() => {
    if (skeletonRef.current) skeletonBoxRef.current = boxOf(skeletonRef.current);
    for (const order of orders) openedRef.current.add(order.orderId);
  });
  if (orders.length === 0) return loading ? /* @__PURE__ */ jsx(OrderStatusCardSkeleton, { ref: skeletonRef }) : null;
  const arriving = orders.filter((order) => !openedRef.current.has(order.orderId));
  const renderCard = (order, index) => {
    if (!streamed) return /* @__PURE__ */ jsx(OrderStatusCard, { order, className: "buyscout-timeline-order-status-card" });
    const sequence = arriving.indexOf(order);
    const fromSkeleton = index === 0 && openedRef.current.size === 0 ? skeletonBoxRef.current : void 0;
    return /* @__PURE__ */ jsx(ArrivingOrderCard, { order, opening: sequence >= 0, from: fromSkeleton, sequence });
  };
  if (orders.length === 1) return renderCard(orders[0], 0);
  return (
    // eslint-disable-next-line jsx-a11y/no-redundant-roles -- WebKit drops list semantics from a list styled without markers unless the role is explicit.
    /* @__PURE__ */ jsx("ul", { role: "list", "aria-label": t("orderStatus.listLabel", { count: orders.length }), className: "buyscout-timeline-order-status", children: orders.map((order, index) => /* @__PURE__ */ jsx("li", { className: "buyscout-timeline-order-status-item", children: renderCard(order, index) }, order.orderId)) })
  );
}
export {
  OrderStatusTimelineItem
};
//# sourceMappingURL=OrderStatusTimelineItem.mjs.map